import { ChartLineIcon } from '@zep-us/zus-icons';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { DashboardAvailability, useDashboardAvailability } from '@zep/dashboard';
import { ChevronRightIcon } from '../../../../../icons';
interface Props {
  spaceHashId: string;
}
export function LinkToDashboard({
  spaceHashId
}: Props) {
  const dashboardAvailability = useDashboardAvailability({
    spaceHashId
  });
  switch (dashboardAvailability) {
    case DashboardAvailability.ACTIVATED:
    case DashboardAvailability.INACTIVATED_AND_HAS_HISTORY:
      return <Inner spaceHashId={spaceHashId} />;
    case DashboardAvailability.INACTIVATED:
      return null;
  }
}
function Inner({
  spaceHashId
}: {
  spaceHashId: string;
}) {
  const {
    t
  } = useTranslation(['subscription']);
  return <Link className="flex items-center" href={`/dashboard/${spaceHashId}`} target="_blank" data-sentry-element="Link" data-sentry-component="Inner" data-sentry-source-file="LinkToDashboard.tsx">
      <ChartLineIcon className={'mr-3xs size-md text-blue'} data-sentry-element="ChartLineIcon" data-sentry-source-file="LinkToDashboard.tsx" />
      <span className={'text-caption-1 font-medium text-blue md:text-body-1'}>
        {t('subscription:planSpaceCard.4be5fe1e', '데이터 대시보드')}
      </span>
      <ChevronRightIcon className={'size-md text-blue'} data-sentry-element="ChevronRightIcon" data-sentry-source-file="LinkToDashboard.tsx" />
    </Link>;
}